import { useEffect, useMemo, useState } from 'react';
import useLocales from 'src/hooks/useLocales';
import { useNavigate } from 'react-router-dom';
// @mui
import {
  Box,
  Card,
  Table,
  Button,
  TableBody,
  Container,
  TableContainer,
  Grid,
  Stack,
  TableHead,
  TableRow,
  Paper,
  TextField,
  InputAdornment,
  TableCell,
  IconButton,
  Tooltip,
  FormControl,
  Autocomplete,
  Chip,
} from '@mui/material';

import { useSnackbar } from 'notistack';
import { observer } from 'mobx-react-lite';

import PermissionBasedGuard from 'src/guards/PermissionBasedGuard';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import Iconify from 'src/components/Iconify';

import useSettings from 'src/hooks/useSettings';
import { PATH_DASHBOARD } from 'src/routes/paths';
import Page from 'src/components/Page';
import { useStore } from 'src/stores/store';
import { IRentPaymentParams } from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';

import { Controller, useForm } from 'react-hook-form';
import LocalizDatePicker from 'src/sections/common/LocalizDatePicker';
import ContractInfoDetailsToolbar from './ContractInfoDetailsToolbar';
import Loader from 'src/components/loader/Loader';
import MyDialog from 'src/components/MyDialog';
import GenerateRentPaymentList from './GenerateRentPaymentList';
import RentPaymentNewEditForm from '../RentPaymentForm/RentPaymentNewEditForm';
import { GetMonthName } from 'src/sections/common/GetMonthName';
import { DateConverter } from 'src/sections/common/DateConverter';
import Label from 'src/components/Label';
import RentPaymentDelete from './RentPaymentDelete';
import RentPaymentDetailTable from '../RentPaymentDetails/RentPaymentDetailTable';
import { RHFSelect } from 'src/components/hook-form';

// ----------------------------------------------------------------------

type paymentStatusType = {
  value?: number,
  text?: string,
}
export default observer(function RentPaymentList() {
  const { RentPaymentStore } = useStore();
  const { translate } = useLocales();
  const {
    loadRentPayment,
    RentPaymentList,

    openCreateDialog,
    setOpenCloseCreateDialog,
    setOpenCloseGeneratRentListDialog,
    openGeneratRentListDialog,
    loadRentPaymentDetail,
    setOpenCloseDeleteDialog,
    setOpenCloseDetailsDialog,
    openDeleteDialog,
    openDetailsDialog,
  } = RentPaymentStore;

  const { themeStretch } = useSettings();
  const [isloading, setIsloading] = useState(false);
  const [year, setYear] = useState<string>(''); // State for the year
  const [month, setMonth] = useState<string>(''); // State for the month

  const [RentPaymentId, setRentPaymentId] = useState<number>(0);
  const [searchBy, setSearchBy] = useState<string>('');
  const [paymentType, setPaymentType] = useState<paymentStatusType>({ value: 1, text: 'All' });
  //#region create modal
  const handleOpenCreateModal = async (id: number) => {
    await loadRentPaymentDetail({ rentPaymentId: id }).then(() => {
      setOpenCloseCreateDialog();
      setRentPaymentId(id);
    });
  };

  const handleCloseCreateModal = () => {
    setOpenCloseCreateDialog();
  };

  const handleOpenDeleteModal = async (id: number) => {
    await loadRentPaymentDetail({ rentPaymentId: id }).then(() => {
      setOpenCloseDeleteDialog();
      setRentPaymentId(id);
    });
  };

  const handleCloseDeleteModal = () => {
    setOpenCloseDeleteDialog();
  };

  const handleOpenDetailsModal = async (id: number) => {
    await loadRentPaymentDetail({ rentPaymentId: id }).then(() => {
      setOpenCloseDetailsDialog();
      setRentPaymentId(id);
    });
  };

  const handleCloseDetailsModal = () => {
    setOpenCloseDetailsDialog();
  };
  //#endregion

  //#region create modal
  const handleOpenGeneratRentListModal = () => {
    setOpenCloseGeneratRentListDialog();
  };

  const handleCloseGeneratRentListModal = () => {
    setOpenCloseGeneratRentListDialog();
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchBy(event.target.value); // Update state when input changes
  };





  const defaultValues = useMemo<IRentPaymentParams>(
    () => ({
      years: new Date(),
      paymentStatus: 1
    }),
    []
  );
  const methods = useForm<IRentPaymentParams>({
    defaultValues,
  });
  const { watch, control } = methods;
  const val = watch();
  const yearsDate = watch('years'); // Watching the 'years' field

  useEffect(() => {
    if (yearsDate) {
      const changeDateToDateFormat = new Date(yearsDate);

      // Extract Persian year and month
      const persianYear = changeDateToDateFormat.toLocaleString('fa-IR-u-ca-persian', {
        year: 'numeric',
      });
      const persianMonth = changeDateToDateFormat.toLocaleString('fa-IR-u-ca-persian', {
        month: 'numeric',
      });

      // Convert Persian numerals to Western numerals
      const westernYear = persianYear.replace(/[۰-۹]/g, (digit) =>
        '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit).toString()
      );
      const westernMonth = persianMonth.replace(/[۰-۹]/g, (digit) =>
        '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit).toString()
      );

      // Update state with Western year and month
      setYear(westernYear);
      setMonth(westernMonth);
    }
  }, [yearsDate]);


  const Search = async (e: any) => {
    e.preventDefault();
    setIsloading(true);
    loadRentPayment({
      years: Number(year),
      months: Number(month),
      searchBy: searchBy,
    })
      .then((res) => {
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(false);
      });
  };

  const getUserDataFromLocalStorage: any = localStorage.getItem('userData');

  const changeLocalStorgeStringToValue = JSON.parse(getUserDataFromLocalStorage);

  const is_super_admin = changeLocalStorgeStringToValue.IsSuperAdmin;

  const PaymentStatus = [
    { value: 1, text: 'All' },
    { value: 2, text: 'Paid' },
    { value: 3, text: 'Unpaid' },
  ]
  const filteredList = RentPaymentList.filter((row) => {
    if (!paymentType) return true; // fallback safety

    if (paymentType.value === 1) return true; // All
    if (paymentType.value === 2) return row.remainAmount === 0; // Paid
    if (paymentType.value === 3) return row.remainAmount !== 0; // Unpaid
    return true;
  });

  return (
    <Page title={translate('RentPayment.Title')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('RentPayment.Title')}
          links={[
            { name: `${translate('Department.Dashboard')}`, href: PATH_DASHBOARD.root },

            { name: `${translate('RentPayment.Title')}` },
          ]}
          action={
            <>
              <PermissionBasedGuard permissions={['RentPayment-Create']}>
                <Button
                  variant="contained"
                  startIcon={<Iconify icon="eva:plus-fill" />}
                  onClick={() => handleOpenGeneratRentListModal()}
                >
                  {/* {translate('CRUD.GenerateRe')} */}
                  Generate Rent Payment List
                </Button>
              </PermissionBasedGuard>
            </>
          }
        />

        <Grid
          container
          display="flex"
          alignItems="center"
          justifyContent="center" // Use justifyContent instead of justifyItems
        >
          <Grid item xs={12} md={12} spacing={2}>
            <Card
              sx={{
                p: 3,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center', // Use justifyContent instead of justifyItems
              }}
            >
              <Grid item xs={12} md={12}>
                <Box
                  sx={{
                    display: 'grid',
                    columnGap: 2,
                    rowGap: 3,
                    gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(5, 1fr)' },
                  }}
                >
                  <LocalizDatePicker
                    name="years"
                    label={translate('RentPayment.FromDate')}
                    control={control}
                    size={'small'}
                    views={['year', 'month']}
                  />
                  <Controller
                    name="paymentStatus"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <Autocomplete
                        fullWidth
                        freeSolo
                        // onChange={(event, newValue) => setFloor(newValue.value)}
                        onChange={(event, newValue) => {
                          setPaymentType(newValue)
                        }}
                        options={PaymentStatus.map((option: any) => option)}
                        value={paymentType}
                        getOptionLabel={(option) => option.text}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              {...getTagProps({ index })}
                              key={option.value}
                              size="small"
                              label={option.value}
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={translate('RentPayment.PaymentStatus')}
                            error={!!error}
                            size="small"

                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                  />
                  {/* <FormControl>
                   
                    <RHFSelect

                      name="paymentStatus"
                      label={translate('User.Language')}
                      showAsterisk={true}
                      placeholder="language"
                    >
                      <option value="" />
                      {PaymentStatus.map((lang) => (
                        <option key={lang.value} value={lang.value}>
                          {lang.text}
                        </option>
                      ))}
                    </RHFSelect>
                  </FormControl> */}

                  <TextField
                    name="searchBy"
                    fullWidth
                    placeholder={translate('RentPayment.SearchBy')}
                    onChange={handleSearchChange} // Handle changes
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Iconify
                            icon={'eva:search-fill'}
                            sx={{ color: 'text.disabled', width: 20, height: 20 }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />

                  <Button
                    sx={{ width: '120px' }}
                    variant="contained"
                    onClick={Search}
                    startIcon={<Iconify icon="eva:search-fill" />}
                  >
                    {translate('ElectricityPayment.Filter')}
                  </Button>
                </Box>
              </Grid>
              <Grid
                item
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} // Use justifyContent instead of justifyItems
              >
                <ContractInfoDetailsToolbar Report={filteredList} />
              </Grid>
            </Card>
          </Grid>
        </Grid>

        <Grid item xs={12} md={12} sx={{ mt: 2 }}>
          <>
            {isloading ? (
              <Loader />
            ) : (
              <>
                <Stack sx={{ p: 1 }}>
                
                  <TableContainer sx={{ maxHeight: 600 }} component={Paper}>
                    <Table stickyHeader sx={{ minWidth: 700 }} aria-label="customized table">
                      <TableHead>
                        <TableRow>
                          <TableCell>{translate('GeneralFields.No')}</TableCell>
                          <TableCell>{translate('RentPayment.Year')}</TableCell>
                          <TableCell>{translate('RentPayment.Month')}</TableCell>
                          <TableCell>{translate('RentPayment.CustomerName')}</TableCell>
                          <TableCell>{translate('RentPayment.ShopCode')}</TableCell>
                          <TableCell>{translate('RentPayment.RecievedByUserName')}</TableCell>
                          <TableCell>{translate('RentPayment.RemainFromThePast')}</TableCell>
                          <TableCell>{translate('RentPayment.PaymentAmount')}</TableCell>
                          <TableCell>{translate('RentPayment.PaidAmount')}</TableCell>
                          <TableCell>{translate('RentPayment.RemainAmount')}</TableCell>
                          <TableCell>{translate('RentPayment.PaymentDate')}</TableCell>
                          <TableCell>{translate('GeneralFields.Action')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredList.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell component="th" scope="row">
                              {index + 1}
                            </TableCell>
                            <TableCell align="center">
                              {' '}
                              <Label color="warning"> {row.year}</Label>
                            </TableCell>
                            <TableCell align="center">
                              <Label color="success"> {GetMonthName(row.month)}</Label>
                            </TableCell>
                            <TableCell align="center">{row.customerName}</TableCell>
                            <TableCell align="center">{row.shopCode}</TableCell>
                            <TableCell align="center">{row.recievedByUserName}</TableCell>
                            <TableCell align="center">{row.remnantsOfThePast}</TableCell>
                            <TableCell align="center">{row.paymentAmount}</TableCell>
                            <TableCell align="center">{row.paidAmount}</TableCell>
                            <TableCell align="center">
                              {row.remainAmount === 0 ? (
                                <Label color="warning"> {translate('RentPayment.Paid')}</Label>
                              ) : (
                                row.remainAmount
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {row.paymentDate !== null ? (
                                <DateConverter date={row.paymentDate} />
                              ) : (
                                ''
                              )}
                            </TableCell>
                            <TableCell align="center" style={{ display: 'flex' }}>
                              <PermissionBasedGuard permissions={['RentPayment-Update']}>
                                {row.remainAmount !== 0 && (
                                  <Tooltip title={translate('RentPayment.Recieve')}>
                                    <IconButton
                                      color="primary"
                                      size="small"
                                      onClick={() => {
                                        if (row.rentPaymentId) {
                                          handleOpenCreateModal(row.rentPaymentId);
                                        }
                                      }}
                                    >
                                      <Iconify icon="eva:download-outline" width={20} height={20} />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </PermissionBasedGuard>

                              {/* <PermissionBasedGuard permissions={['RentPayment-Delete']}> */}
                              {is_super_admin && (
                                <Tooltip title={translate('CRUD.Delete')}>
                                  <IconButton
                                    color="error"
                                    size="small"
                                    onClick={() => {
                                      if (row.rentPaymentId) {
                                        handleOpenDeleteModal(row.rentPaymentId);
                                      }
                                    }}
                                  >
                                    <Iconify icon="eva:trash-2-outline" width={20} height={20} />
                                  </IconButton>
                                </Tooltip>
                              )}

                              <Tooltip title={translate('CRUD.Detail')}>
                                <IconButton
                                  color="primary"
                                  size="small"
                                  onClick={() => {
                                    if (row.rentPaymentId) {
                                      handleOpenDetailsModal(row.rentPaymentId); // You should define this function
                                    }
                                  }}
                                >
                                  <Iconify icon="eva:eye-outline" width={20} height={20} />
                                </IconButton>
                              </Tooltip>
                              {/* </PermissionBasedGuard> */}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Stack>
              </>
            )}

            <MyDialog
              open={openGeneratRentListDialog}
              onClose={handleCloseGeneratRentListModal}
              title={translate('RentPayment.Generat')}
              size="md"
            >
              <GenerateRentPaymentList />
            </MyDialog>

            <MyDialog
              open={openCreateDialog}
              onClose={handleCloseCreateModal}
              title={translate('RentPayment.Title')}
              size="md"
            >
              <RentPaymentNewEditForm id={RentPaymentId} />
            </MyDialog>

            <MyDialog
              open={openDeleteDialog}
              onClose={handleCloseDeleteModal}
              title={translate('RentPayment.Delete')}
              size="md"
            >
              <RentPaymentDelete
                year={Number(year)}
                month={Number(month)}
                searchBy={searchBy}
                id={RentPaymentId}
              />
            </MyDialog>

            <MyDialog
              open={openDetailsDialog}
              onClose={handleCloseDetailsModal}
              title=""
              size="xl"
            >
              <RentPaymentDetailTable

              />
            </MyDialog>
          </>
        </Grid>
      </Container>
    </Page>
  );
});
